import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  createUser,
  sendOtpSignup,
  verifyOtpPass,
} from "../../../services/auth/auth";
import toast from "react-hot-toast";
import { addToWishlist } from "../../../services/wishlist";
import { addItemToCart } from "../../../services/cart";
import { verifyOTP } from "../../../services/auth/firebase/verifyOtp";
import { resetForgetPassword } from "../../../services/user";
// import { useAuth } from "../../utils/AuthContext";

function useOtp() {
  const navigate = useHistory();

  const userData = sessionStorage.getItem("userData") || "{}";
  const cachedData = JSON.parse(userData);

  // States to track loading state
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerifyOtpPass, setIsVerifyOtpPass] = useState(false);

  const syncGuestData = async () => {
    try {
      // Get guest cart and wishlist from localStorage
      const guestCart = JSON.parse(localStorage.getItem("cartGuest") || "[]");
      const guestWishlist = JSON.parse(
        localStorage.getItem("guestWishlist") || "[]"
      );

      // Sync wishlist items
      const wishlistPromises = guestWishlist.map((item) =>
        addToWishlist(item.productId).catch((error) => {
          console.error("Error syncing wishlist item:", error);
          return null;
        })
      );
      await Promise.all(wishlistPromises);

      // Sync cart items
      const cartPromises = guestCart.map((item) =>
        addItemToCart(item.productId, item.quantity).catch((error) => {
          console.error("Error syncing cart item:", error);
          return null;
        })
      );
      await Promise.all(cartPromises);

      // Clear guest data from localStorage
      localStorage.removeItem("cartGuest");
      localStorage.removeItem("guestWishlist");

      toast.success("Your cart and wishlist have been synchronized");
    } catch (error) {
      console.error("Error syncing guest data:", error);
      toast.error("Failed to sync some items");
    }
  };

  // Function to send OTP
  const sendOtpFn = async ({ data, mobile }) => {
    setIsSendingOtp(true);
    // console.log("data: ", data, "mobile: ", mobile);
    try {
      const response = await sendOtpSignup(
        data,
        mobile,
        Object.entries(data).length === 0 ? "password" : "signup"
      );
      sessionStorage.setItem("userData", JSON.stringify(response));

      // toast.success("OTP Sent Successfully!");
    } catch (error) {
      toast.error("Some Error Occurred!");
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Function to verify OTP and create user
  const verifyOtpFn = async (otp) => {
    if (!cachedData) {
      toast.error("No user data found. Please start over.");
      return;
    }
    setIsVerifying(true);
    try {
      const idToken = await verifyOTP(otp);
      await createUser(idToken, cachedData);
      // Sync guest data after successful registration
      await syncGuestData();
      navigate.push("/signin");
      toast.success("Account has been created Successfully!");
      sessionStorage.clear();
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Some Error Occurred!"
      );
    } finally {
      setIsVerifying(false);
    }
  };

  // Function to verify OTP for password reset
  const verifyOtpPassFn = async (otp) => {
    setIsVerifyOtpPass(true);
    try {
      const idToken = await verifyOtpPass(otp);
      //   setIsReset(true);
      // console.log("id token is: ", idToken);
      sessionStorage.setItem("idToken", idToken);
      sessionStorage.setItem("isResetting", "true");
      toast.success("Verifying...");
      navigate.push("/reset-password");
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : "Some Error Occurred!"
      );
    } finally {
      setIsVerifyOtpPass(false);
    }
  };

  return {
    sendOtpFn,
    isSendingOtp,

    verifyOtpFn,
    isVerifying,

    verifyOtpPassFn,
    isVerifyOtpPass,
  };
}

export default useOtp;
